import React from 'react';
import cx from 'classnames';
import SplitView from '../../../../split-view/split-view';
import RobotTabs, { RobotTabsContent } from '../../../__tabs/robot__tabs';
import { ROBOT_TABS } from '../../../robot.types';
import { RobotFieldPane } from '../../../__field-pane/robot__field-pane';
import RobotInfo from '../../../__info/robot__info';
import RobotError from '../../../__error/robot__error';
import { Code } from '../../../__code-container/robot__code-container';
import { useRobotSelector } from '../../../context';
import { ROBOT_FIELD_MIN_WIDTH } from '../../../consts';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot_view_python_desktop.module.scss';

export const RobotViewPythonDesktop = () => {
    const teacherMode = useRobotSelector((store) => store.teacherMode);

    return (
        <SplitView className={cx(styles.robot, 'qa_robot')} minSizes={[ROBOT_FIELD_MIN_WIDTH, 340]}>
            <RobotFieldPane withSandbox={!teacherMode} />
            <div className={cx(styles.right, 'qa_robot-editor')}>
                <RobotTabs />
                <RobotTabsContent>
                    {{
                        [ROBOT_TABS.INFO]: (
                            <div className={cx(styles.info, { [styles.info_teacher]: teacherMode })}>
                                <RobotInfo />
                            </div>
                        ),
                        [ROBOT_TABS.CODE]: (
                            <div
                                className={cx(
                                    styles.code,
                                    { [styles.code_teacher]: teacherMode },
                                    'qa_robot-python-editor'
                                )}
                            >
                                <RobotError className={styles.error} />
                                <Code />
                            </div>
                        ),
                    }}
                </RobotTabsContent>
            </div>
        </SplitView>
    );
};
